<template>
  <div>
    <b-modal
      :model-value="modCreaReporte"
      :no-close-on-backdrop="true"
      hide-footer
      centered
      :title="labels.title"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog create-reporte-dialog"
      @hide="closeModal"
    >
      <div class="uniform-modal-body">
        <div class="password-policy-box mb-4">
          <div class="password-policy-title">{{ labels.infoTitle }}</div>
          <div class="password-policy-subtitle">{{ labels.infoText }}</div>
        </div>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.codigo }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-input 
              v-model="codigo" 
              type="number" 
              class="form-input" 
              autocomplete="off"
              :placeholder="labels.codigoPlaceholder"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.nombre }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-input 
              v-model="nombre" 
              type="text" 
              class="form-input" 
              autocomplete="off"
              :placeholder="labels.nombrePlaceholder"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.principal }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-select 
              v-model="principal" 
              class="form-input"
            >
              <b-form-select-option value="">{{ labels.select }}</b-form-select-option>
              <b-form-select-option value="1">{{ labels.yes }}</b-form-select-option>
              <b-form-select-option value="0">{{ labels.not }}</b-form-select-option>
            </b-form-select>
          </b-col>
        </b-row>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.libro_notas }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-input 
              v-model="libro_notas" 
              type="text" 
              class="form-input" 
              autocomplete="off"
              :placeholder="labels.libroNotasPlaceholder"
            ></b-form-input>
          </b-col>
        </b-row>

        <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
          <b-button class="mr-2 reset-btn-secondary" @click="closeModal()">
            {{ labels.cerrar }}
          </b-button>
          <b-button class="reset-btn-primary" @click="guardaReporte()">
            {{ labels.guardar }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TipoReporte from '../../../services/TipoReporte'

export default {
  name: 'CreaReporte',
  props: ['modCreaReporte'],
  data: () => ({
    codigo: '',
    nombre: '',
    principal: '',
    libro_notas: '',
  }),
  computed: {
    labels() {
      const isEs = this.$store.state._language == "es-ES"
      return {
        title: isEs ? 'Crear Reporte' : 'Create Report',
        codigo: isEs ? 'Código' : 'Code',
        nombre: isEs ? 'Nombre' : 'Name',
        principal: isEs ? 'Principal' : 'Principal',
        libro_notas: isEs ? 'Libro Notas' : 'Notes',
        select: isEs ? 'Seleccione...' : 'Select...',
        yes: isEs ? 'SI' : 'YES',
        not: isEs ? 'NO' : 'NO',
        guardar: isEs ? 'Guardar' : 'Save',
        cerrar: isEs ? 'Cerrar' : 'Close',
        infoTitle: isEs ? 'Datos del reporte' : 'Report information',
        infoText: isEs ? 'Completa la información y guarda el nuevo reporte.' : 'Complete the information and save the new report.',
        codigoPlaceholder: isEs ? 'Código del reporte' : 'Report code',
        nombrePlaceholder: isEs ? 'Nombre del reporte' : 'Report name',
        libroNotasPlaceholder: isEs ? 'Libro de notas' : 'Notes book'
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal', false)
      this.clearCampos()
    },
    clearCampos() {
      this.codigo = ''
      this.nombre = ''
      this.principal = ''
      this.libro_notas = ''
    },
    guardaReporte() {
      if (this.codigo == '' || this.nombre == '' || this.principal == '') {
        this.$toast.error('Campo(s) pendiente(s) por diligenciar')
        return
      }

      const dataReport = {
        codigo: this.codigo,
        nombre: this.nombre,
        principal: this.principal,
        libro_notas: this.libro_notas || '',
        idUser: this.$store.state.userId || 1
      }

      TipoReporte.createReporte(dataReport)
        .then((res) => {
          if (res.status == 201 || res.status == 200) {
            this.$toast.success(res.data.message || 'Reporte creado exitosamente')
            this.$emit('refrescaTbl')
            this.closeModal()
          }
        })
        .catch((error) => {
          console.error(error)
          this.$toast.error(error.response?.data?.message || 'No se pudo crear el reporte')
        })
    }
  }
}
</script>

<style scoped>
/* Estilos heredados de main.css, solo específicos si es necesario */
</style>